<template>
  <div
    class="checkin"
    :style="`background:${bgcolor};padding-top:${banner_list.length>0?'0rem':'2rem'}`"
  >
    <div v-if="banner_list.length>0" class="banner">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(row, index) in banner_list" :key="index">
          <a :href="row.jumpurl">
            <img :src="row.imgurl" />
          </a>
        </van-swipe-item>
      </van-swipe>
      <svg class="svg" width="100%" height="2.75rem" viewBox="0 0 750 110">
        <g
          id="页面-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          opacity="0.303713"
        >
          <g
            id="画板-copy-6"
            transform="translate(0.000000, -442.000000)"
            :fill="bgcolor"
            fill-rule="nonzero"
          >
            <path
              d="M0,458.93083 C8.40624224,440.316633 43.6567327,437.04298 105.751471,449.109871 C198.893579,467.210207 258.208903,515.474071 343.284769,523.818784 C427.307426,523.818784 430.968581,489.343703 467.499323,489.061131 C504.030065,488.77856 498.748919,520.08021 573.742456,520.08021 C622.563421,520.08021 637.122326,484.187611 679.002038,464.681332 C706.921846,451.677146 730.703561,455.454477 750.347182,476.013327 L750.347182,551.343703 L0,551.343703 L0,458.93083 Z"
              id="矩形"
            />
          </g>
        </g>
      </svg>
      <svg class="svg" width="100%" height="2.25rem" viewBox="0 0 750 90">
        <g
          id="页面-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          opacity="0.339285714"
        >
          <g
            id="画板-copy-6"
            transform="translate(0.000000, -461.000000)"
            :fill="bgcolor"
            fill-rule="nonzero"
          >
            <path
              d="M0,506.126356 C50.1079997,513.58899 93.2135338,514.68639 129.316602,509.418556 C182.711536,501.627649 200.44015,457.697923 285.874793,461.185604 C330.965479,463.026332 388.649031,512.74981 433.268115,516.475339 C517.944899,523.545538 523.52861,487 577.447617,487 C611.093823,487 618.033015,512.112924 676.462225,516.475339 C718.839134,519.639265 743.400556,516.189604 750.146492,506.126356 L750.146492,551.126356 L0,551.126356 L0,506.126356 Z"
              id="矩形"
            />
          </g>
        </g>
      </svg>
    </div>
    <div class="body">
      <div class="user">
        <div class="top">
          <div class="left">
            <img v-if="current.avatar" :src="current.avatar" />
            <div class="name">
              <span>参赛选手</span>
              <span>{{current.name}}</span>
            </div>
          </div>
          <div class="right">
            <img @click="show=true" src="../../assets/qrcode.png" />
          </div>
        </div>
        <div v-if="needcheckin!=2" class="bottom">
          <div class="button">{{current.ischeckin==2?'检录/签到':'取消检录/签到'}}</div>
        </div>
      </div>
      <div class="info">
        <div class="title">选手信息</div>
        <div class="row" v-if="needcheckin!=2">
          <div class="key">状态</div>
          <div class="show">{{current._ischeckin}}</div>
        </div>
        <div v-for="(row, index) in show_list" :key="index" class="row">
          <template v-if="row.show_name=='参赛证书'">
            <div class="key">{{row.show_name}}</div>
            <div class="show">
              <a :href="current[row.key_name]" target="_blank" rel="noopener noreferrer">证书下载</a>
            </div>
          </template>
          <template v-else>
            <div class="key">{{row.show_name}}</div>
            <div class="show">{{current[row.key_name]}}</div>
          </template>
        </div>
      </div>
    </div>
    <van-popup v-model="show">
      <div class="dialog">
        <div class="intro">请向工作人员出示此二维码</div>
        <qriously :value="$route.params.id" :size="200" />
        <div class="code">({{$route.params.id}})</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  getCheckinConfig,
  getCheckinInfo,
  getBanners,
  cerateCert
} from "../../libs/api";
export default {
  data() {
    return {
      show: false,
      clear: true,
      keyword: "",
      bgcolor: "#f4f4f4",
      needcheckin: 2,
      ischeckin: 2,
      show_list: [],
      current: {},
      name: {
        number: "参赛号码",
        cert: "参赛证书",
        name: "姓名",
        gender: "性别",
        groupname: "团队名称",
        unit: "单位名称",
        phone: "手机号",
        idcard: "证件号码",
        gun_score: "枪声成绩",
        chip_score: "净成绩",
        ischeckin: "状态"
      },
      list: [],
      banner_list: [],
      timer: null
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.timer = setInterval(() => {
          this.get_checkin_info();
        }, 500);
      } else {
        clearInterval(this.timer);
      }
    }
  },
  mounted() {
    this.get_checkin_info();
    this.get_banners();
  },
  methods: {
    get_checkin_config() {
      getCheckinConfig({ checkinid: this.$route.query.checkinid }).then(r => {
        this.needcheckin = r.data.needcheckin;
        let list = [];
        let list1 = JSON.parse(r.data.checkinfields).sysfields;
        let list2 = JSON.parse(r.data.checkinfields).extrainfo;

        //证书
        if (r.data.searchcert == 1 && !this.current.cert) {
          cerateCert({
            enrollid: this.current.id
          }).then(re => {
            this.current = re.data;
          });
        }
        list1.forEach(row => {
          let show_name = this.name[row];
          if (row == "name" || row == "ischeckin") {
            return;
          }
          if (!this.current[row]) {
            this.current[row] = "暂无";
          }
          list.push({
            key_name: row,
            show_name: show_name
          });
        });
        list2.forEach(row => {
          list.push({
            key_name: row,
            show_name: row
          });
        });
        this.show_list = list;
        if (r.data.backgroundimage) {
          this.bgcolor = `url(${r.data.backgroundimage}) no-repeat center center/cover`;
        } else {
          if (r.data.backgroundcolor) {
            this.bgcolor = `#${r.data.backgroundcolor}`;
          } else {
            this.bgcolor = "#f4f4f4";
          }
        }
      });
    },
    get_checkin_info() {
      if (!this.clear) {
        return;
      }
      this.clear = false;
      let ischeckin = this.current.ischeckin;
      getCheckinInfo({
        enrollid: this.$route.params.id,
        checkinid: this.$route.query.checkinid
      })
        .then(r => {
          this.clear = true;
          switch (r.data.ischeckin * 1) {
            case 1:
              r.data._ischeckin = "已签到/检录";
              break;
            case 2:
              r.data._ischeckin = "未操作";
              break;
          }
          if (ischeckin && ischeckin != r.data.ischeckin) {
            this.show = false;
            let message = "";
            switch (r.data.ischeckin * 1) {
              case 1:
                message = "签到/检录 成功！";
                break;
              case 2:
                message = "取消 签到/检录 成功！";
                break;
            }
            this.$dialog.alert({
              title: "提示",
              message: message
            });
          }
          this.ischeckin = r.data.ischeckin;
          let obj = {};
          if (r.data.extrainfo) {
            obj = JSON.parse(r.data.extrainfo);
          }
          obj = Object.assign({}, obj, r.data);
          this.current = obj;
          if (!this.show) {
            this.get_checkin_config();
          }
        })
        .catch(r => {
          this.show = false;
        });
    },
    get_banners() {
      getBanners({
        position: 4,
        positionid: this.$route.query.checkinid
      }).then(r => {
        this.banner_list = r.data;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.checkin {
  background: #f4f4f4;
  min-height: 100vh;
  .banner {
    height: 8.8rem;
    font-size: 0;
    position: relative;
    .svg {
      position: absolute;
      bottom: -10px;
      left: 0;
      right: 0;
      pointer-events: none;
    }
    a {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
  .body {
    padding: 0 0.75rem 1rem;
    .user,
    .info {
      background: #fff;
      border-radius: 0.7rem;
      padding: 1.5rem 1rem 1rem;
    }
    .user {
      margin-top: 1.2rem;
      padding: 1.5rem 1rem;
      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          display: flex;
          align-items: center;
          img {
            width: 2.4rem;
            height: 2.4rem;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 0.8rem;
          }
          .name {
            font-size: 0.8rem;
            display: flex;
            flex-direction: column;
            line-height: 1.5;
            span {
              &:first-child {
                color: #999;
              }
            }
          }
        }
        .right {
          img {
            width: 1.75rem;
            height: 1.75rem;
          }
        }
      }
      .bottom {
        margin-top: 1.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        .button {
          display: inline-block;
          font-size: 0.8rem;
          color: #fff;
          background: #69aeff;
          padding: 0.2rem 2rem;
          border-radius: 1rem;
          box-shadow: 0 2px 7px rgba(0, 0, 0, 0.2);
          transition: all 0.2s;
          &:active {
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
            transition: all 0.2s;
            background: #5c9feb;
          }
        }
      }
    }
    .info {
      margin-top: 1.2rem;
      .title {
        font-size: 0.9rem;
        color: #393940;
        margin-bottom: 0.8rem;
      }
      .row {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 0.75rem;
        padding: 0.5rem 0;
        .key {
          color: #999;
          width: 40%;
        }
      }
    }
  }
  .dialog {
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .intro {
      font-size: 0.8rem;
      margin-bottom: 0.6rem;
    }
    .code {
      font-size: 0.7rem;
      margin-top: 0.6rem;
      color: #999;
    }
  }
}
</style>
